import { h, Fragment } from "preact";

import { Coupon } from "../../../foundation/api/model";
import Tax from "../../../foundation/api/model/stripe/Tax";
import { BillingPeriod } from "../../../foundation/enums";
import classname from "../../../foundation/utils/classname";
import { formatCurrency } from "../../../foundation/utils/legacy";

import { formatPriceForUI, getDurationText } from "../../../foundation/utils/payment";

import styles from "./SubTotalPrice.module.css";

interface Props {
    taxes?: Tax[];
    appliedCoupon?: Coupon;
    billingPeriod: BillingPeriod;
    totalPrice: number;
}

function getDiscountNotice({ coupon, period }: { coupon: Coupon; period: BillingPeriod; }): string {
    const discountText = coupon.percent_off
        ? `${coupon.percent_off}% off`
        : `${formatCurrency(coupon.amount_off / 100)} off`;

    return `${discountText} ${getDurationText(coupon, period)}`;
}

export default function SubTotalPrice({
    taxes, appliedCoupon, totalPrice, billingPeriod
}: Props) {
    if ((!taxes || !taxes.length) && !appliedCoupon) {
        return null;
    }

    return (
        <>
            <div class={styles.subtotalPriceContainer}>
                <div class={classname(styles.subtotalRow, "body-1", "medium")}>
                    <div>Subtotal</div>
                    <div>{formatCurrency(totalPrice)}</div>
                </div>
                {appliedCoupon && (
                    <div className={classname(styles.subtotalRow, styles.dimmed, "body-1", "medium")}>
                        <div>
                            <span>
                            🎟{" "}Coupon applied for{" "}
                                {getDiscountNotice({ coupon: appliedCoupon, period: billingPeriod })}
                            </span>
                        </div>
                        <div>
                            -{formatCurrency(appliedCoupon.percent_off
                                ? totalPrice * (appliedCoupon.percent_off / 100)
                                : formatPriceForUI(appliedCoupon.amount_off))}
                        </div>
                    </div>
                )}
                {taxes && taxes.map(tax => (
                    <div className={classname(styles.subtotalRow, styles.dimmed, "body-1", "medium")}>
                        <div>
                            {`${tax.name} (${tax.percentage}%${tax.state ? ` ${tax.state}` : ""})`}
                        </div>
                        <div>
                            {formatCurrency(formatPriceForUI(tax.amount))}
                        </div>
                    </div>
                ))}
            </div>
            <hr/>
        </>
    );
}
